import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { EditPage, EditPageTextField, EditPageCheckbox, EditPagePanel } from '../../common/EditPage';
import { getOne, update } from '../../common/v4/BackendProvider';
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const ResellerEdit = () => {
    const [data, setData] = useState({});
    const {reseller_id} = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        getOne(`/admin/resellers/resellers/`, reseller_id)
            .then(response => {
                setData(response.data);
            }).catch(error => {
                toast.error("Error fetching reseller: " + error.message, {});
            });
    }, [reseller_id]);

    const handleSave = () => {
        update(`/admin/resellers/resellers/`, reseller_id, {data: data}).then(response => {
            toast.success("Reseller updated successfully", {});
            navigate('/resellers/resellers');
        }).catch(error => {
            toast.error("Error updating reseller: " + error.message, {});
        });
    };

    const handleCancel = () => {
        navigate('/resellers/resellers');
    };

    const onChange = (id, value) => {
        setData({...data, [id]: value});
    };
    return (
        <>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                closeOnClick={true}
                pauseOnHover={true}
            draggable={true}
            progress="undefined"
        />
            <EditPage handleSave={ handleSave } handleCancel={ handleCancel } >
                <EditPagePanel>
                    <EditPageTextField label="Name" id="ATRNAME" onChange={ onChange } value={ data.ATRNAME } />
                    <EditPageTextField label="Email" id="ATREMAIL" onChange={ onChange } value={ data.ATREMAIL } />
                    <EditPageCheckbox label="Active" id="ATRSTATUS" onChange={ onChange } value={ data.ATRSTATUS } />
                </EditPagePanel>
            </EditPage>
        </>
    );
}

export default ResellerEdit;